export const MIN_CLINIC_NAME_LENGTH = 2;
export const MAX_CLINIC_NAME_LENGTH = 200;